import { INVESTMENT_VEHICLES } from './investmentVehicles';

export const INVESTMENT_VEHICLE_COLORS = {
    [INVESTMENT_VEHICLES.EQUITY.name.toLowerCase()]: '#D22248',
    [INVESTMENT_VEHICLES.VENTURE_DEBT.name.toLowerCase()]: '#687579',
    [INVESTMENT_VEHICLES.CONVENTIONAL_DEBT.name.toLowerCase()]: '#951833',
    [INVESTMENT_VEHICLES.GRANT.name.toLowerCase()]: '#8C989C',
    [INVESTMENT_VEHICLES.NON_EQUITY_ASSISTANCE.name.toLowerCase()]: '#EE96A9',
    [INVESTMENT_VEHICLES.LINE_OF_CREDIT.name.toLowerCase()]: '#262A2C',
    [INVESTMENT_VEHICLES.BUYOUT.name.toLowerCase()]: '#580E1E',
    [INVESTMENT_VEHICLES.LEVERAGED_BUYOUT.name.toLowerCase()]: '#E45876',
    [INVESTMENT_VEHICLES.PE_GROWTH.name.toLowerCase()]: '#475052',
    [INVESTMENT_VEHICLES.BOLT_ON.name.toLowerCase()]: '#B8BFC2',
};

export const INVESTMENT_VEHICLE_FALLBACK_COLOR = '#ABB1B3';

export const OTHER_INVESTMENT_VEHICLES_LABEL = 'Other vehicles';
